
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3D12W", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $1yB28 = parcelRequire("1yB28");


var $jypE9 = parcelRequire("jypE9");


var $21K7m = parcelRequire("21K7m");


var $inPa6 = parcelRequire("inPa6");


var $3gadb = parcelRequire("3gadb");


var $aWwYt = parcelRequire("aWwYt");


var $8aF6s = parcelRequire("8aF6s");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $cMvMc = parcelRequire("cMvMc");


var $ep3mz = parcelRequire("ep3mz");


var $fNzRA = parcelRequire("fNzRA");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $iBnoc = parcelRequire("iBnoc");


var $fHAwL = parcelRequire("fHAwL");


var $cZa7r = parcelRequire("cZa7r");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $1ggpj = parcelRequire("1ggpj");


var $8uM2K = parcelRequire("8uM2K");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $404f4d0022b5692a$var$commentIconContainerStyle = null;
const $404f4d0022b5692a$var$iconButtonWrapperStyle = null;
const $404f4d0022b5692a$var$unreadCountBadgeStyle = null;
const $404f4d0022b5692a$var$i18n = (0, $aXWIB.defineMessages)({
    viewAllCommentsLabel: {
        id: "object-sidebar-components.view.all.comments",
        defaultMessage: "View all comments"
    },
    showCommentsLabel: {
        id: "object-sidebar-components.show.comments.label",
        defaultMessage: "Show comments"
    },
    showReactionsLabel: {
        id: "object-sidebar-components.show.reactions.label",
        defaultMessage: "Show reactions"
    }
});
const $404f4d0022b5692a$export$f5ef73dad1bb3f02 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(73);
    const { onClick: onClick, collapsed: collapsed, testId: testId, isStandaloneComment: t1, isDisabled: t2, isViewAllIcon: t3, isReaction: t4 } = t0;
    const isStandaloneComment = t1 === undefined ? false : t1;
    const isDisabled = t2 === undefined ? false : t2;
    const isViewAllIcon = t3 === undefined ? false : t3;
    const isReaction = t4 === undefined ? false : t4;
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { resetInitialDataLoadedMap: resetInitialDataLoadedMap } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { viewProps: viewProps, selectionProps: selectionProps, hoverProps: hoverProps, editorViewProps: editorViewProps, editorCreateProps: editorCreateProps, showCreateComponent: showCreateComponent, selectionOptions: selectionOptions } = (0, $cZa7r.useAnnotations)();
    const { setViewProps: setViewProps, setSelectionProps: setSelectionProps, setHoverProps: setHoverProps, setEditorViewProps: setEditorViewProps, setEditorCreateProps: setEditorCreateProps, setShowCreateComponent: setShowCreateComponent, setSelectionOptions: setSelectionOptions } = (0, $cZa7r.useAnnotationsDispatch)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const panel = (0, $aWwYt.usePanel)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    let t5;
    if ($[0] !== pageMode) {
        t5 = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
        $[0] = pageMode;
        $[1] = t5;
    } else t5 = $[1];
    const eventEmitter = t5;
    const { newCommentHighlight: newCommentHighlight, activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [t6] = (0, $efvKr.useLivePageMode)();
    const { isViewMode: isLiveViewMode, isEditMode: isLiveEditMode } = t6;
    const dataTestId = testId || "object-sidebar-comments-button-id";
    const [contentTypeFromState] = (0, $ep3mz.useContentType)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { closeCommentContainer: closeCommentContainer } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded } = (0, $fNzRA.useObjectCommentContext)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const showUnreadCountBadge = !isStandaloneComment && (unreadCommentIDSet?.size ?? 0) > 0;
    const t7 = pageMode === "edit" || isLiveEditMode;
    let t8;
    if ($[2] !== t7) {
        t8 = {
            shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
            isEditorShortcut: t7
        };
        $[2] = t7;
        $[3] = t8;
    } else t8 = $[3];
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t8);
    const isShortcutTextShown = contentTypeFromState !== (0, $1ggpj.ContentType).DATABASE;
    let t9;
    if ($[4] !== pageMode) {
        t9 = ()=>{
            (0, $5fMeR.preloadCommentsPanel)(pageMode);
        };
        $[4] = pageMode;
        $[5] = t9;
    } else t9 = $[5];
    const handleMouseEnter = t9;
    let t10;
    if ($[6] !== activeHighlight || $[7] !== closeCommentContainer || $[8] !== editorCreateProps || $[9] !== editorViewProps || $[10] !== eventEmitter || $[11] !== expanded || $[12] !== hideObjectSidebar || $[13] !== hoverProps || $[14] !== newCommentHighlight || $[15] !== panel?.id || $[16] !== selectionOptions || $[17] !== selectionProps || $[18] !== setEditorCreateProps || $[19] !== setEditorViewProps || $[20] !== setHoverProps || $[21] !== setSelectionOptions || $[22] !== setSelectionProps || $[23] !== setShowCreateComponent || $[24] !== setViewProps || $[25] !== showCommentsPanel || $[26] !== showCreateComponent || $[27] !== viewProps) {
        t10 = ()=>{
            if (viewProps) {
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
                setViewProps(null);
            }
            if (showCreateComponent && selectionOptions) {
                setShowCreateComponent(false);
                setSelectionOptions(undefined);
            }
            if (editorViewProps) {
                eventEmitter.emit("setselectedannotation", "");
                setEditorViewProps(null);
            }
            if (selectionProps) {
                selectionProps.onClose();
                setSelectionProps(null);
            }
            if (hoverProps) {
                hoverProps.onClose();
                setHoverProps(null);
            }
            if (editorCreateProps) {
                editorCreateProps?.onClose && editorCreateProps.onClose();
                setEditorCreateProps(null);
            }
            if (newCommentHighlight || activeHighlight) window.dispatchEvent(new Event("closeLegacyInlineCommentSidebar"));
            if (expanded && !(0, $9wGTI.fg)("confluence_comment_panel_close_footer")) closeCommentContainer();
            if (panel?.id === "commentsPanel") hideObjectSidebar();
            else showCommentsPanel();
        };
        $[6] = activeHighlight;
        $[7] = closeCommentContainer;
        $[8] = editorCreateProps;
        $[9] = editorViewProps;
        $[10] = eventEmitter;
        $[11] = expanded;
        $[12] = hideObjectSidebar;
        $[13] = hoverProps;
        $[14] = newCommentHighlight;
        $[15] = panel?.id;
        $[16] = selectionOptions;
        $[17] = selectionProps;
        $[18] = setEditorCreateProps;
        $[19] = setEditorViewProps;
        $[20] = setHoverProps;
        $[21] = setSelectionOptions;
        $[22] = setSelectionProps;
        $[23] = setShowCreateComponent;
        $[24] = setViewProps;
        $[25] = showCommentsPanel;
        $[26] = showCreateComponent;
        $[27] = viewProps;
        $[28] = t10;
    } else t10 = $[28];
    const handleCommentClick = t10;
    let t11;
    if ($[29] !== contentTypeFromState || $[30] !== createAnalyticsEvent || $[31] !== handleCommentClick || $[32] !== hasContentChanged || $[33] !== onClick || $[34] !== pageMode || $[35] !== resetContentChanged || $[36] !== resetInitialDataLoadedMap || $[37] !== showModal) {
        t11 = (t12)=>{
            const { triggeredByKeyboardShortcut: t13, isViewAllIcon: t14 } = t12 === undefined ? {} : t12;
            const triggeredByKeyboardShortcut = t13 === undefined ? false : t13;
            const isViewAllIcon_0 = t14 === undefined ? false : t14;
            return ()=>{
                if (isViewAllIcon_0) {
                    onClick?.();
                    return;
                }
                if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                    onConfirm: ()=>{
                        resetContentChanged();
                        handleCommentClick();
                        resetInitialDataLoadedMap();
                    }
                });
                else handleCommentClick();
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "commentsPanel",
                        source: "contentWrapper",
                        attributes: {
                            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                            contentType: contentTypeFromState,
                            pageMode: pageMode
                        }
                    }
                }).fire();
            };
        };
        $[29] = contentTypeFromState;
        $[30] = createAnalyticsEvent;
        $[31] = handleCommentClick;
        $[32] = hasContentChanged;
        $[33] = onClick;
        $[34] = pageMode;
        $[35] = resetContentChanged;
        $[36] = resetInitialDataLoadedMap;
        $[37] = showModal;
        $[38] = t11;
    } else t11 = $[38];
    const checkUnsavedOnClickCommentsButton = t11;
    let t12;
    if ($[39] !== checkUnsavedOnClickCommentsButton || $[40] !== isLiveViewMode || $[41] !== pageMode) {
        t12 = (pageMode === "view" || isLiveViewMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: (0, $gnkil.TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER),
            accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
            listener: checkUnsavedOnClickCommentsButton({
                triggeredByKeyboardShortcut: true
            })
        });
        $[39] = checkUnsavedOnClickCommentsButton;
        $[40] = isLiveViewMode;
        $[41] = pageMode;
        $[42] = t12;
    } else t12 = $[42];
    let t13;
    if ($[43] !== checkUnsavedOnClickCommentsButton || $[44] !== isLiveEditMode || $[45] !== pageMode) {
        t13 = (pageMode === "edit" || isLiveEditMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
            listener: checkUnsavedOnClickCommentsButton({
                triggeredByKeyboardShortcut: true
            })
        });
        $[43] = checkUnsavedOnClickCommentsButton;
        $[44] = isLiveEditMode;
        $[45] = pageMode;
        $[46] = t13;
    } else t13 = $[46];
    let t14;
    if ($[47] !== t12 || $[48] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t12, t13);
        $[47] = t12;
        $[48] = t13;
        $[49] = t14;
    } else t14 = $[49];
    const shortcutListeners = t14;
    if (collapsed) return shortcutListeners;
    let t15;
    if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = (0, $gMc0m.default)([
            "_kqswh2mm"
        ]);
        $[50] = t15;
    } else t15 = $[50];
    const t16 = isReaction && (0, $6mKj3.expVal)("confluence_inline_reactions", "isEnabled", false) ? $404f4d0022b5692a$var$i18n.showReactionsLabel : $404f4d0022b5692a$var$i18n.showCommentsLabel;
    let t17;
    if ($[51] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), t16);
        $[51] = t16;
        $[52] = t17;
    } else t17 = $[52];
    const t18 = isShortcutTextShown ? commentShortcutStrings : undefined;
    let t19;
    if ($[53] !== allowComments || $[54] !== checkUnsavedOnClickCommentsButton || $[55] !== formatMessage || $[56] !== handleMouseEnter || $[57] !== isDisabled || $[58] !== isRovoButtonEnabled || $[59] !== isStandaloneComment || $[60] !== isViewAllIcon || $[61] !== showUnreadCountBadge || $[62] !== unreadCommentIDSet) {
        t19 = allowComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (0, $6mKj3.expVal)("cc_spark_show_unread_count_in_comments_button", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            className: (0, $gMc0m.default)([
                "_kqswh2mm _1e0c116y"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            onClick: checkUnsavedOnClickCommentsButton({
                isViewAllIcon: isViewAllIcon
            }),
            onMouseEnter: handleMouseEnter,
            appearance: "subtle",
            spacing: isStandaloneComment ? "compact" : undefined,
            shape: isRovoButtonEnabled ? "default" : "circle",
            icon: isStandaloneComment && (0, $6mKj3.expValEquals)("confluence_comments_cohiti_panel_icon_update", "isEnabled", true) ? (0, (/*@__PURE__*/$parcel$interopDefault($jypE9))) : (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
            label: formatMessage($404f4d0022b5692a$var$i18n.viewAllCommentsLabel),
            testId: "sidebar-comments-button",
            interactionName: "view-comments-menu-action",
            isDisabled: isDisabled && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false)
        }), showUnreadCountBadge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-testid": "comment-button-unread-count-badge",
            className: (0, $gMc0m.default)([
                "_2rko1v6z _1yt41nxw _kqswstnw _154iidpf _1xi2idpf _1ul9dlk8 _4t3idlk8 _bfhkx4w0 _syaz15cr _1wybrdoj _k48p8n31 _1e0c1txw _4cvr1h6o _1bah1h6o _lcxvglyw _vchhusvi _1pbykb7n"
            ])
        }, unreadCommentIDSet.size > 9 ? "9+" : String(unreadCommentIDSet.size))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            onClick: checkUnsavedOnClickCommentsButton({
                isViewAllIcon: isViewAllIcon
            }),
            onMouseEnter: handleMouseEnter,
            appearance: "subtle",
            spacing: isStandaloneComment ? "compact" : undefined,
            shape: isRovoButtonEnabled ? "default" : "circle",
            icon: isStandaloneComment && (0, $6mKj3.expValEquals)("confluence_comments_cohiti_panel_icon_update", "isEnabled", true) ? (0, (/*@__PURE__*/$parcel$interopDefault($jypE9))) : (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
            label: formatMessage($404f4d0022b5692a$var$i18n.viewAllCommentsLabel),
            testId: "sidebar-comments-button",
            interactionName: "view-comments-menu-action",
            isDisabled: isDisabled && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false)
        }), !isStandaloneComment && unreadCommentIDSet?.size > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iBnoc.UnreadIndicator), null)));
        $[53] = allowComments;
        $[54] = checkUnsavedOnClickCommentsButton;
        $[55] = formatMessage;
        $[56] = handleMouseEnter;
        $[57] = isDisabled;
        $[58] = isRovoButtonEnabled;
        $[59] = isStandaloneComment;
        $[60] = isViewAllIcon;
        $[61] = showUnreadCountBadge;
        $[62] = unreadCommentIDSet;
        $[63] = t19;
    } else t19 = $[63];
    const t20 = !isStandaloneComment && shortcutListeners;
    let t21;
    if ($[64] !== t17 || $[65] !== t18 || $[66] !== t19 || $[67] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "left",
            content: t17,
            shortcut: t18,
            delay: 0,
            hideTooltipOnClick: true
        }, t19, t20);
        $[64] = t17;
        $[65] = t18;
        $[66] = t19;
        $[67] = t20;
        $[68] = t21;
    } else t21 = $[68];
    let t22;
    if ($[69] !== dataTestId || $[70] !== t15 || $[71] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": dataTestId,
            "data-vc": "object-sidebar-comments-button",
            className: t15
        }, t21);
        $[69] = dataTestId;
        $[70] = t15;
        $[71] = t21;
        $[72] = t22;
    } else t22 = $[72];
    return t22;
} : ({ onClick: onClick, collapsed: collapsed, testId: testId, isStandaloneComment: isStandaloneComment = false, isDisabled: isDisabled = false, isViewAllIcon: isViewAllIcon = false, isReaction: isReaction = false })=>{
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { resetInitialDataLoadedMap: resetInitialDataLoadedMap } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { viewProps: viewProps, selectionProps: selectionProps, hoverProps: hoverProps, editorViewProps: editorViewProps, editorCreateProps: editorCreateProps, showCreateComponent: showCreateComponent, selectionOptions: selectionOptions } = (0, $cZa7r.useAnnotations)();
    const { setViewProps: setViewProps, setSelectionProps: setSelectionProps, setHoverProps: setHoverProps, setEditorViewProps: setEditorViewProps, setEditorCreateProps: setEditorCreateProps, setShowCreateComponent: setShowCreateComponent, setSelectionOptions: setSelectionOptions } = (0, $cZa7r.useAnnotationsDispatch)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const panel = (0, $aWwYt.usePanel)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const { newCommentHighlight: newCommentHighlight, activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [{ isViewMode: isLiveViewMode, isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const dataTestId = testId || 'object-sidebar-comments-button-id';
    const [contentTypeFromState] = (0, $ep3mz.useContentType)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { closeCommentContainer: closeCommentContainer } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded } = (0, $fNzRA.useObjectCommentContext)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const showUnreadCountBadge = !isStandaloneComment && (unreadCommentIDSet?.size ?? 0) > 0;
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        isEditorShortcut: pageMode === 'edit' || isLiveEditMode
    }); // keyboard events do not bubble up to confluence when focus is in the db iframe.
    // Since the keyboard shortcut does not work, we must hide the shortcut text.
    const isShortcutTextShown = contentTypeFromState !== (0, $1ggpj.ContentType).DATABASE; // Preload components on hover to improve FMP performance
    const handleMouseEnter = (0, $42omo.useCallback)(()=>{
        (0, $5fMeR.preloadCommentsPanel)(pageMode);
    }, [
        pageMode
    ]);
    const handleCommentClick = (0, $42omo.useCallback)(()=>{
        // FABRIC PAGES
        // Close the view component if it's open
        if (viewProps) {
            // Inform the Renderer to de-select the annotation
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS); // Remove the display of the comment
            setViewProps(null);
        }
        if (showCreateComponent && selectionOptions) {
            // Inform CreateComment to reset the state
            setShowCreateComponent(false);
            setSelectionOptions(undefined);
        }
        if (editorViewProps) {
            // Inform the editor to de-select the annotation
            eventEmitter.emit('setselectedannotation', ''); // Remove the display of the comment
            setEditorViewProps(null);
        }
        if (selectionProps) {
            selectionProps.onClose();
            setSelectionProps(null);
        }
        if (hoverProps) {
            hoverProps.onClose();
            setHoverProps(null);
        }
        if (editorCreateProps) {
            editorCreateProps?.onClose && editorCreateProps.onClose();
            setEditorCreateProps(null);
        } // LEGACY PAGES
        if (newCommentHighlight || activeHighlight) // Close the legacy inline comment panel
        window.dispatchEvent(new Event('closeLegacyInlineCommentSidebar'));
         // Should unmount the expanded comment editor
        // standalone reply, object footer comment
        if (expanded && !(0, $9wGTI.fg)('confluence_comment_panel_close_footer')) closeCommentContainer();
        if (panel?.id === 'commentsPanel') hideObjectSidebar();
        else showCommentsPanel();
    }, [
        eventEmitter,
        viewProps,
        editorViewProps,
        selectionProps,
        hoverProps,
        newCommentHighlight,
        activeHighlight,
        setViewProps,
        setEditorViewProps,
        setSelectionProps,
        setHoverProps,
        showCommentsPanel,
        hideObjectSidebar,
        panel,
        editorCreateProps,
        closeCommentContainer,
        expanded,
        setEditorCreateProps,
        showCreateComponent,
        selectionOptions,
        setShowCreateComponent,
        setSelectionOptions
    ]);
    const checkUnsavedOnClickCommentsButton = (0, $42omo.useCallback)(({ triggeredByKeyboardShortcut: triggeredByKeyboardShortcut = false, isViewAllIcon: isViewAllIcon_0 = false } = {})=>()=>{
            // Early return for ViewAll icon - no action needed
            if (isViewAllIcon_0) {
                onClick?.();
                return;
            }
            if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged();
                    handleCommentClick();
                    resetInitialDataLoadedMap();
                }
            });
            else handleCommentClick();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'commentsPanel',
                    source: 'contentWrapper',
                    attributes: {
                        triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                        contentType: contentTypeFromState,
                        pageMode: pageMode
                    }
                }
            }).fire();
        }, [
        onClick,
        hasContentChanged,
        handleCommentClick,
        resetContentChanged,
        resetInitialDataLoadedMap,
        showModal,
        createAnalyticsEvent,
        contentTypeFromState,
        pageMode
    ]);
    const shortcutListeners = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (pageMode === 'view' || isLiveViewMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: (0, $gnkil.TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER),
        accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        listener: checkUnsavedOnClickCommentsButton({
            triggeredByKeyboardShortcut: true
        })
    }), (pageMode === 'edit' || isLiveEditMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        listener: checkUnsavedOnClickCommentsButton({
            triggeredByKeyboardShortcut: true
        })
    }));
    if (collapsed) return shortcutListeners;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": dataTestId,
        "data-vc": "object-sidebar-comments-button",
        className: (0, $gMc0m.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "left",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), isReaction && (0, $6mKj3.expVal)('confluence_inline_reactions', 'isEnabled', false) ? $404f4d0022b5692a$var$i18n.showReactionsLabel : $404f4d0022b5692a$var$i18n.showCommentsLabel),
        shortcut: isShortcutTextShown ? commentShortcutStrings : undefined,
        delay: 0,
        hideTooltipOnClick: true
    }, allowComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (0, $6mKj3.expVal)('cc_spark_show_unread_count_in_comments_button', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_kqswh2mm _1e0c116y"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        onClick: checkUnsavedOnClickCommentsButton({
            isViewAllIcon: isViewAllIcon
        }),
        onMouseEnter: handleMouseEnter,
        appearance: "subtle",
        spacing: isStandaloneComment ? 'compact' : undefined,
        shape: isRovoButtonEnabled ? 'default' : 'circle',
        icon: isStandaloneComment && (0, $6mKj3.expValEquals)('confluence_comments_cohiti_panel_icon_update', 'isEnabled', true) ? (0, (/*@__PURE__*/$parcel$interopDefault($jypE9))) : (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
        label: formatMessage($404f4d0022b5692a$var$i18n.viewAllCommentsLabel),
        testId: "sidebar-comments-button",
        interactionName: "view-comments-menu-action",
        isDisabled: isDisabled && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
    }), showUnreadCountBadge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "comment-button-unread-count-badge",
        className: (0, $gMc0m.default)([
            "_2rko1v6z _1yt41nxw _kqswstnw _154iidpf _1xi2idpf _1ul9dlk8 _4t3idlk8 _bfhkx4w0 _syaz15cr _1wybrdoj _k48p8n31 _1e0c1txw _4cvr1h6o _1bah1h6o _lcxvglyw _vchhusvi _1pbykb7n"
        ])
    }, unreadCommentIDSet.size > 9 ? '9+' : String(unreadCommentIDSet.size))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        onClick: checkUnsavedOnClickCommentsButton({
            isViewAllIcon: isViewAllIcon
        }),
        onMouseEnter: handleMouseEnter,
        appearance: "subtle",
        spacing: isStandaloneComment ? 'compact' : undefined,
        shape: isRovoButtonEnabled ? 'default' : 'circle',
        icon: isStandaloneComment && (0, $6mKj3.expValEquals)('confluence_comments_cohiti_panel_icon_update', 'isEnabled', true) ? (0, (/*@__PURE__*/$parcel$interopDefault($jypE9))) : (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
        label: formatMessage($404f4d0022b5692a$var$i18n.viewAllCommentsLabel),
        testId: "sidebar-comments-button",
        interactionName: "view-comments-menu-action",
        isDisabled: isDisabled && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
    }), !isStandaloneComment && unreadCommentIDSet?.size > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iBnoc.UnreadIndicator), null))), !isStandaloneComment && shortcutListeners));
};
module.exports["CommentPanelButton"] = $404f4d0022b5692a$export$f5ef73dad1bb3f02;

});

parcelRegister("cMvMc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f2899d935411e961$export$fb31a121515f224d = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "_Vqh0",
    name: "CommentWarningDialog",
    loader: async ()=>(await (parcelRequire("8FCWK"))).CommentWarningDialog
});
module.exports["CommentWarningDialog"] = $f2899d935411e961$export$fb31a121515f224d;

});

parcelRegister("8FCWK", function(module, exports) {

let $65005d03f1075b43$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $65005d03f1075b43$var$load("hhss7"),
    $65005d03f1075b43$var$load("cqNU4")
]).then(()=>parcelRequire('9c4UU'));

});

parcelRegister("fNzRA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $en1dX = parcelRequire("en1dX");


var $irVI7 = parcelRequire("irVI7");


var $8Ss4E = parcelRequire("8Ss4E");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");

var $7b4a2f6cc35c72e1$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    // The footer comments section
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    // The sticky draft that persists outside of the footer
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
const $7b4a2f6cc35c72e1$export$8a175172a11240d4 = /*#__PURE__*/ (0, $42omo.createContext)({
    expandCommentContainer: ()=>{},
    closeCommentContainer: ()=>{},
    setWrapperWidth: ()=>{},
    setIsObjectCommentWrapperVisible: ()=>{},
    setFooterEditorEntry: ()=>{}
});
$7b4a2f6cc35c72e1$export$8a175172a11240d4.displayName = 'ObjectCommentDispatchContext';
const $7b4a2f6cc35c72e1$export$358734f355c08965 = /*#__PURE__*/ (0, $42omo.createContext)({
    expanded: false,
    footerEditorEntry: undefined,
    width: undefined,
    isObjectCommentWrapperVisible: false
});
$7b4a2f6cc35c72e1$export$358734f355c08965.displayName = 'ObjectCommentContext';
const $7b4a2f6cc35c72e1$export$d248a0e4aca56201 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { children: children } = t0;
    const [expanded, setExpanded] = (0, $42omo.useState)(false);
    const [footerEditorEntry, setFooterEditorEntry] = (0, $42omo.useState)(undefined);
    const [width, setWidth] = (0, $42omo.useState)(undefined);
    const [isObjectCommentWrapperVisible, setIsObjectCommentWrapperVisible] = (0, $42omo.useState)(false);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] !== expanded || $[1] !== footerEditorEntry || $[2] !== isObjectCommentWrapperVisible || $[3] !== width) {
        t1 = {
            expanded: expanded,
            footerEditorEntry: footerEditorEntry,
            width: width,
            isObjectCommentWrapperVisible: isObjectCommentWrapperVisible
        };
        $[0] = expanded;
        $[1] = footerEditorEntry;
        $[2] = isObjectCommentWrapperVisible;
        $[3] = width;
        $[4] = t1;
    } else t1 = $[4];
    const providerValue = t1;
    let t2;
    if ($[5] !== edition) {
        t2 = (props)=>{
            const { entryPoint: entryPoint } = props ?? {};
            if (entryPoint && (0, $9wGTI.fg)("confluence_fe_add_page_comment_exp_coverage")) (0, $8Ss4E.startEditorExperiences)({
                name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                attributes: {
                    editor: "FABRIC",
                    isSingleExperience: true,
                    edition: edition,
                    source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                    entryPoint: entryPoint
                }
            }, {
                name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
            }, {
                name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
            });
            setExpanded(true);
        };
        $[5] = edition;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setFooterEditorEntry(undefined);
            setExpanded(false);
        };
        t4 = (width_0)=>{
            setWidth(width_0 ? `${width_0}px` : "100%");
        };
        t5 = (visible)=>{
            setIsObjectCommentWrapperVisible(visible);
        };
        t6 = (footerEditorEntry_0)=>{
            setFooterEditorEntry(footerEditorEntry_0);
        };
        $[7] = t3;
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    } else {
        t3 = $[7];
        t4 = $[8];
        t5 = $[9];
        t6 = $[10];
    }
    let t7;
    if ($[11] !== t2) {
        t7 = {
            expandCommentContainer: t2,
            closeCommentContainer: t3,
            setWrapperWidth: t4,
            setIsObjectCommentWrapperVisible: t5,
            setFooterEditorEntry: t6
        };
        $[11] = t2;
        $[12] = t7;
    } else t7 = $[12];
    const dispatchProviderValue = t7;
    let t8;
    if ($[13] !== children || $[14] !== dispatchProviderValue) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$8a175172a11240d4.Provider, {
            value: dispatchProviderValue
        }, children);
        $[13] = children;
        $[14] = dispatchProviderValue;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== providerValue || $[17] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$358734f355c08965.Provider, {
            value: providerValue
        }, t8);
        $[16] = providerValue;
        $[17] = t8;
        $[18] = t9;
    } else t9 = $[18];
    return t9;
} : ({ children: children })=>{
    const [expanded, setExpanded] = (0, $42omo.useState)(false);
    const [footerEditorEntry, setFooterEditorEntry] = (0, $42omo.useState)(undefined);
    const [width, setWidth] = (0, $42omo.useState)(undefined);
    const [isObjectCommentWrapperVisible, setIsObjectCommentWrapperVisible] = (0, $42omo.useState)(false);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const providerValue = (0, $42omo.useMemo)(()=>({
            expanded: expanded,
            footerEditorEntry: footerEditorEntry,
            width: width,
            isObjectCommentWrapperVisible: isObjectCommentWrapperVisible
        }), [
        expanded,
        footerEditorEntry,
        width,
        isObjectCommentWrapperVisible
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            expandCommentContainer: (props)=>{
                const { entryPoint: entryPoint } = props ?? {};
                if (entryPoint && (0, $9wGTI.fg)('confluence_fe_add_page_comment_exp_coverage')) (0, $8Ss4E.startEditorExperiences)({
                    name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                    attributes: {
                        editor: 'FABRIC',
                        isSingleExperience: true,
                        edition: edition,
                        source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                        entryPoint: entryPoint
                    }
                }, {
                    name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
                }, {
                    name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
                });
                setExpanded(true);
            },
            closeCommentContainer: ()=>{
                setFooterEditorEntry(undefined);
                setExpanded(false);
            },
            setWrapperWidth: (width_0)=>{
                setWidth(width_0 ? `${width_0}px` : '100%');
            },
            setIsObjectCommentWrapperVisible: (visible)=>{
                setIsObjectCommentWrapperVisible(visible);
            },
            setFooterEditorEntry: (footerEditorEntry_0)=>{
                setFooterEditorEntry(footerEditorEntry_0);
            }
        }), [
        setExpanded,
        setFooterEditorEntry,
        setWidth,
        setIsObjectCommentWrapperVisible,
        edition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$358734f355c08965.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$8a175172a11240d4.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $7b4a2f6cc35c72e1$export$da430766ddf17a6b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$358734f355c08965);
} : ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$358734f355c08965);
};
const $7b4a2f6cc35c72e1$export$8ba3235fe153fa01 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$8a175172a11240d4);
} : ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$8a175172a11240d4);
};
module.exports["AddFooterCommentMode"] = $7b4a2f6cc35c72e1$export$94f8d08c2312472b;
module.exports["ObjectCommentProvider"] = $7b4a2f6cc35c72e1$export$d248a0e4aca56201;
module.exports["useObjectCommentContext"] = $7b4a2f6cc35c72e1$export$da430766ddf17a6b;
module.exports["useObjectCommentDispatchContext"] = $7b4a2f6cc35c72e1$export$8ba3235fe153fa01;

});

parcelRegister("en1dX", function(module, exports) {
var $88e03e673e36ecc4$export$6890652a1aff7d1c = /*#__PURE__*/ function(AnalyticsSource) {
    AnalyticsSource["COMMENTS_PANEL"] = "commentsPanel";
    AnalyticsSource["STANDALONE"] = "standalone";
    AnalyticsSource["PAGE_FOOTER"] = "pageFooter";
    return AnalyticsSource;
}({});
var $88e03e673e36ecc4$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["REOPEN_COMMENT"] = "reopenComment";
    return ActionName;
}({});
var $88e03e673e36ecc4$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    CommentType["PAGE"] = "page";
    return CommentType;
}({});
module.exports["AnalyticsSource"] = $88e03e673e36ecc4$export$6890652a1aff7d1c;
module.exports["ActionName"] = $88e03e673e36ecc4$export$9c95d6e1614bad84;
module.exports["CommentType"] = $88e03e673e36ecc4$export$ffa1150e6a48f9cd;

});

parcelRegister("bSvtO", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $45ca38ec521afdf7$var$initialState = {
    hasContentChanged: false,
    isCommentContentReady: false
};
const $45ca38ec521afdf7$export$53ac33307b5acee9 = ()=>({
        hasContentChanged: false,
        isCommentContentReady: false
    });
const $45ca38ec521afdf7$export$e324594224ef24da = {
    onChange: (hasChanges)=>({ setState: setState })=>{
            setState({
                hasContentChanged: hasChanges
            });
        },
    resetContentChanged: ()=>({ setState: setState })=>{
            setState({
                hasContentChanged: false
            });
        },
    onCommentContentReady: ()=>({ setState: setState })=>{
            setState({
                isCommentContentReady: true
            });
        }
};
const $45ca38ec521afdf7$var$CommentsContentStore = (0, $1P1Tu.createStore)({
    initialState: $45ca38ec521afdf7$var$initialState,
    actions: $45ca38ec521afdf7$export$e324594224ef24da,
    name: 'CommentsContentStore'
});
const $45ca38ec521afdf7$export$ef1bfc0b6758ca67 = (0, $9zUhf.createHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$e2038e591f93e866 = (0, $9zUhf.createActionsHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$1756d05b0495e6b = (0, $9zUhf.createStateHook)($45ca38ec521afdf7$var$CommentsContentStore);
module.exports["useCommentsContentActions"] = $45ca38ec521afdf7$export$e2038e591f93e866;
module.exports["useCommentsContentState"] = $45ca38ec521afdf7$export$1756d05b0495e6b;

});

parcelRegister("5fMeR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $21K7m = parcelRequire("21K7m");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $cZa7r = parcelRequire("cZa7r");


var $3mVfX = parcelRequire("3mVfX");


var $ep3mz = parcelRequire("ep3mz");


var $dANtQ = parcelRequire("dANtQ");


var $gEtAQ = parcelRequire("gEtAQ");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $gtj7V = parcelRequire("gtj7V");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $bSvtO = parcelRequire("bSvtO");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


var $kDhla = parcelRequire("kDhla");


const $3b7f940e5fdc8097$var$CommentsPanelFilterMenu = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Cp4VO",
    name: "CommentsPanelFilterMenu",
    loader: async ()=>(await (parcelRequire("l2zNi"))).CommentsPanelFilterMenu
});

const $3b7f940e5fdc8097$var$CommentsPanelFooter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "V6uhH",
    name: "CommentsPanelFooter",
    loader: async ()=>(await (parcelRequire("cdvIH"))).CommentsPanelFooter
});

const $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EqpEC",
    name: "CommentsPanelHeaderIcon",
    loader: async ()=>(await (parcelRequire("6PB7O"))).CommentsPanelHeaderIcon
});

const $3b7f940e5fdc8097$var$CommentsPanelWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "r3W5r",
    name: "CommentsPanelWrapper",
    loader: async ()=>(await (parcelRequire("eIWjB"))).CommentsPanelWrapper
});

const $3b7f940e5fdc8097$var$CommentsPanelFooterWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uSRQM",
    name: "CommentsPanelFooterWrapper",
    loader: async ()=>(await (parcelRequire("k1YtK"))).CommentsPanelFooterWrapper
});

const $3b7f940e5fdc8097$var$CommentsPanelFilterMenuWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "GWpr1",
    name: "CommentsPanelFilterMenuWrapper",
    loader: async ()=>(await (parcelRequire("aOVTE"))).CommentsPanelFilterMenuWrapper
});
const $3b7f940e5fdc8097$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    commentsPanelHeaderLabel: {
        id: "comments-panel.panel.header.label",
        defaultMessage: "Comments"
    },
    discussionsPanelHeaderLabel: {
        id: "comments-panel.panel.header.discussions.label",
        defaultMessage: "Discussions"
    }
});
const $3b7f940e5fdc8097$export$b215887829902b28 = (pageMode)=>{
    // Always preload the core components
    $3b7f940e5fdc8097$var$CommentsPanelWrapper.preload();
    $3b7f940e5fdc8097$var$CommentsPanelFilterMenu.preload();
    $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon.preload();
    // Only preload footer in view mode (not edit mode)
    if (pageMode !== (0, $cD1qu.PageMode).EDIT) $3b7f940e5fdc8097$var$CommentsPanelFooter.preload();
};
const $3b7f940e5fdc8097$export$833f9a16214bbf3d = ()=>{
    const isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
    const isDatabaseView = (0, $gEtAQ.isDatabase)();
    const isWhiteboardView = (0, $gEtAQ.isWhiteboard)();
    const isSlidesView = (0, $gEtAQ.isSlides)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setViewProps: setViewProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { currentSidebarTab: currentSidebarTab } = (0, $3mVfX.useCommentsPanelState)();
    const { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId, setCurrentSidebarTab: setCurrentSidebarTab } = (0, $3mVfX.useCommentsPanelActions)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '', true);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    // a ref is needed here because of a closure issue with canClosePanel
    const hasContentChangedRef = (0, $42omo.useRef)(hasContentChanged);
    (0, $42omo.useEffect)(()=>{
        hasContentChangedRef.current = hasContentChanged;
    }, [
        hasContentChanged
    ]);
    const { fullPageEditorPresetAPI: fullPageEditorPresetAPI } = (0, $kDhla.useFullPageEditorApiState)();
    (0, $42omo.useEffect)(()=>{
        fullPageEditorPresetAPI?.aiSuggestions?.actions.setUIVisibility(isObjectSidebarShown);
    }, [
        isObjectSidebarShown,
        fullPageEditorPresetAPI
    ]);
    (0, $42omo.useEffect)(()=>{
        /**
     * When leaving the Suggestions tab, deselect the suggestion
     */ if (currentSidebarTab !== (0, $3mVfX.SidebarTabValues).SUGGESTIONS) fullPageEditorPresetAPI?.aiSuggestions?.actions.selectSuggestion(null);
    }, [
        currentSidebarTab,
        fullPageEditorPresetAPI
    ]);
    const onPanelCloseFunction = ()=>{
        setCurrentView(undefined);
        setCurrentSidebarTab((0, $3mVfX.SidebarTabValues).COMMENTS);
        // Unselect active annotations on the page
        if (pageMode === (0, $cD1qu.PageMode).VIEW) {
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
            setViewProps(null);
        } else {
            eventEmitter.emit('setselectedannotation', '');
            setEditorViewProps(null);
        }
        // clear selected comment thread in the comments panel
        setCurrentlySelectedThreadKey('');
        setReplyToCommentId();
    };
    const onPanelCloseCallback = (0, $42omo.useCallback)(onPanelCloseFunction, [
        setCurrentView,
        pageMode,
        eventEmitter,
        setViewProps,
        setEditorViewProps,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId,
        setCurrentSidebarTab
    ]);
    const onPanelClose = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? onPanelCloseCallback : onPanelCloseFunction;
    const canClosePanel = (0, $42omo.useCallback)(async ()=>{
        if (hasContentChangedRef.current && !(0, $9wGTI.fg)('confluence_comments_fix_duplicate_modal')) return new Promise((resolve)=>{
            showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged && resetContentChanged();
                    resolve(true);
                },
                onCancel: ()=>{
                    resolve(false);
                }
            });
        });
        else return true;
    }, [
        resetContentChanged,
        showModal
    ]);
    const showCommentsPanelFunction = ({ openWithView: openWithView, openWithTab: openWithTab } = {})=>{
        if (!allowComments) return;
        experienceTracker.start({
            name: (0, $irVI7.SIDEBAR_COMMENTS_PANEL_LOAD_EXPERIENCE),
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                openWithView: openWithView,
                ...(0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) && {
                    openWithTab: openWithTab
                },
                contentId: contentId,
                pageMode: pageMode
            }
        });
        const loadFooterComments = pageMode !== (0, $cD1qu.PageMode).EDIT;
        // Drag-to-resize on page surfaces only (same exclusions as the panel
        // itself). `expValEquals` is the LAST clause per
        // `confluence-feature-gating/no-preconditioning` so exposure is only
        // recorded for users who actually meet the surface preconditions.
        const isResizableSurface = !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && !isSlidesView && (0, $6mKj3.expValEquals)('confluence_fe_comments_panel_resize', 'isEnabled', true);
        const showFooter = canAddComments && contentStatus !== (0, $cD1qu.ContentStatus).DRAFT && loadFooterComments && !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && !isSlidesView;
        /**
     * Logic for showing the footer for platform_editor_ai_content_suggested_edits
     * There is additional logic for comments vs. suggestions inside CommentsPanelFooterWrapper
     */ const showFooterCommon = !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && !isSlidesView;
        // When the gate is on, use CommentsPanelFooterWrapper which reactively
        // switches between SuggestionsFooter and CommentsPanelFooter based on
        // the current tab — without needing to re-open the sidebar.
        // When the gate is off, fall back to the original CommentsPanelFooter.
        const FooterComponent = showFooterCommon ? $3b7f940e5fdc8097$var$CommentsPanelFooterWrapper : undefined;
        const OldFooterComponent = showFooter ? $3b7f940e5fdc8097$var$CommentsPanelFooter : undefined;
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).CommentsPanel,
            headerComponentElements: {
                HeaderIcon: $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon,
                headerLabel: (0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) ? $3b7f940e5fdc8097$export$a7357cdd1f0b0168.discussionsPanelHeaderLabel : $3b7f940e5fdc8097$export$a7357cdd1f0b0168.commentsPanelHeaderLabel,
                HeaderRightAlignedElement: (0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) ? $3b7f940e5fdc8097$var$CommentsPanelFilterMenuWrapper : $3b7f940e5fdc8097$var$CommentsPanelFilterMenu
            },
            BodyComponent: ()=>$3b7f940e5fdc8097$var$CommentsPanelWrapper({
                    openWithView: openWithView,
                    openWithTab: openWithTab
                }),
            FooterComponent: (0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) ? FooterComponent : OldFooterComponent,
            closeOptions: {
                canClosePanel: canClosePanel,
                onPanelClose: onPanelClose
            },
            isResizable: isResizableSurface
        }, 'push');
    };
    const showCommentsPanelHandler = (0, $42omo.useCallback)(showCommentsPanelFunction, [
        allowComments,
        canAddComments,
        canClosePanel,
        contentId,
        contentStatus,
        experienceTracker,
        isDatabaseView,
        isSpaceOverviewPage,
        isWhiteboardView,
        isSlidesView,
        onPanelClose,
        pageMode,
        showObjectSidebar
    ]);
    const showCommentsPanel = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? showCommentsPanelHandler : showCommentsPanelFunction;
    // NOTE: Exposing the hide function for now while we have the CommentButton
    return {
        isCommentsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel,
        showCommentsPanel: showCommentsPanel,
        hideCommentsPanel: hideObjectSidebar
    };
};
module.exports["preloadCommentsPanel"] = $3b7f940e5fdc8097$export$b215887829902b28;
module.exports["useShowCommentsPanel"] = $3b7f940e5fdc8097$export$833f9a16214bbf3d;

});

parcelRegister("7aw3q", function(module, exports) {

var $1iSzD = parcelRequire("1iSzD");


var $9bL1w = parcelRequire("9bL1w");


var $cxu5H = parcelRequire("cxu5H");

const $440129e2f2e8f952$export$d22f0c9bbe97be97 = ()=>{
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { hasComments: hasPageComments, hasInlineCommentsAndHighlightActions: hasViewInlineComments } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const { hasInlineCommentsAndHighlightActions: hasEditInlineComments } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    if (!isEmbeddedConfluence) return true;
    const allowPageCommentsInEmbeddedMode = hasPageComments;
    const allowInlineCommentsInEmbeddedMode = hasViewInlineComments || hasEditInlineComments;
    return allowPageCommentsInEmbeddedMode && allowInlineCommentsInEmbeddedMode;
};
module.exports["useEmbeddedComments"] = $440129e2f2e8f952$export$d22f0c9bbe97be97;

});

parcelRegister("3mVfX", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $8i27m = parcelRequire("8i27m");


var $kgNLQ = parcelRequire("kgNLQ");

var $4440a0699c7a4c4d$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    ViewValues["MENTIONS_ME"] = "MENTIONS_ME";
    return ViewValues;
}({});
var $4440a0699c7a4c4d$export$edda0a7e0ba757fd = /*#__PURE__*/ function(SortValues) {
    SortValues["PAGE_ORDER"] = "PAGE_ORDER";
    SortValues["MOST_RECENT"] = "MOST_RECENT";
    return SortValues;
}({});
var $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c = /*#__PURE__*/ function(CommentMode) {
    CommentMode["VIEW"] = "view";
    CommentMode["ADD"] = "add";
    return CommentMode;
}({});
var $4440a0699c7a4c4d$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
var $4440a0699c7a4c4d$export$6a393d893fab1730 = /*#__PURE__*/ function(SidebarTabValues) {
    SidebarTabValues["COMMENTS"] = "COMMENTS";
    SidebarTabValues["SUGGESTIONS"] = "SUGGESTIONS";
    return SidebarTabValues;
}({});
const $4440a0699c7a4c4d$var$getInitialState = ()=>({
        currentView: undefined,
        currentSort: "PAGE_ORDER",
        showInlineComments: true,
        showGeneralComments: true,
        currentlySelectedThreadKey: undefined,
        isCurrentlySelectedThreadOptimisticallyAdded: false,
        initialDataLoadedForViewMap: {
            ["UNREAD"]: false,
            ["OPEN"]: false,
            ["DELETED_CONTENT"]: false,
            ["RESOLVED"]: false,
            ["MENTIONS_ME"]: false
        },
        replyToCommentId: undefined,
        replyToCommentUser: undefined,
        footerEditCommentIds: new Set(),
        currentlyRenderedThreads: [],
        location: undefined,
        commentType: undefined,
        commentMode: "view",
        isCommentAddPromptFocused: false,
        commentContainerToFocus: undefined,
        addFooterCommentAdf: undefined,
        cachedSummary: null,
        currentSidebarTab: "COMMENTS"
    });
// Actions for managing the comments state in the comments panel
const $4440a0699c7a4c4d$var$actions = {
    getCommentsPanelState: ()=>({ getState: getState })=>{
            return getState();
        },
    setCurrentView: (view)=>({ setState: setState })=>{
            setState({
                currentView: view
            });
        },
    setCurrentSort: (sort)=>({ setState: setState })=>{
            setState({
                currentSort: sort
            });
        },
    setShowInlineComments: (showInline)=>({ setState: setState })=>{
            setState({
                showInlineComments: showInline
            });
        },
    setShowGeneralComments: (showGeneral)=>({ setState: setState })=>{
            setState({
                showGeneralComments: showGeneral
            });
        },
    setCurrentlySelectedThreadKey: (threadKey, commentType, isOptimisticAddSuccess)=>({ getState: getState, setState: setState })=>{
            const { currentlySelectedThreadKey: currentlySelectedThreadKey } = getState();
            if (!!isOptimisticAddSuccess && commentType === (0, $8i27m.CommentType).GENERAL && currentlySelectedThreadKey !== (0, $kgNLQ.OPTIMISTIC_SAVE_COMMENT_ID)) // This means that user has selected a different comment thread
            // after new comment was optimistically added on UI but before
            // the GQL mutation succeeded. In this case, we shouldn't set
            // currentlySelectedThreadKey to the new comment.
            return;
            setState({
                currentlySelectedThreadKey: threadKey,
                commentType: commentType,
                // Note: Added for COMMENTS-6792: Optimistically adding a footer comment.
                // When adding a footer comment optimistically, setCurrentlySelectedThreadKey is
                // called twice: once when the comment is added to UI optimistically with a fake id,
                // and once more when the mutation succeeds and UI is updated with the actual id.
                // The effect of the second call is rendered on UI before the updated comment list
                // is rendered, which causes a visible flicker, where the new comment goes from
                // "selected" -> "unselected" (for an instant) -> "selected" again.
                // To fix this flicker, we keep showing the comment with fake id as "selected" when
                // this flag is true, even if value of `currentlySelectedThreadKey` has changed.
                isCurrentlySelectedThreadOptimisticallyAdded: commentType === (0, $8i27m.CommentType).GENERAL && !!isOptimisticAddSuccess
            });
        },
    setInitialDataLoadedForView: ({ viewToSetLoaded: viewToSetLoaded })=>({ getState: getState, setState: setState })=>{
            const { initialDataLoadedForViewMap: initialDataLoadedForViewMap } = getState();
            initialDataLoadedForViewMap[viewToSetLoaded] = true;
            setState({
                initialDataLoadedForViewMap: initialDataLoadedForViewMap
            });
        },
    setReplyToCommentId: ({ parentCommentId: parentCommentId, location: location, user: user } = {})=>({ setState: setState })=>{
            setState({
                replyToCommentId: parentCommentId,
                location: location,
                replyToCommentUser: user
            });
        },
    resetInitialDataLoadedMap: ()=>({ setState: setState })=>{
            setState($4440a0699c7a4c4d$var$getInitialState());
        },
    setCurrentlyRenderedThreads: (threads)=>({ setState: setState })=>{
            setState({
                currentlyRenderedThreads: threads
            });
        },
    addFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.add(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    removeFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.delete(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    setCommentMode: (mode)=>({ setState: setState })=>{
            setState({
                commentMode: mode
            });
        },
    setIsCommentAddPromptFocused: (isFocused)=>({ setState: setState })=>{
            setState({
                isCommentAddPromptFocused: isFocused
            });
        },
    resetCommentMode: ()=>({ setState: setState })=>{
            setState({
                commentMode: "view",
                isCommentAddPromptFocused: false
            });
        },
    setCommentContainerToFocus: (commentContainerToFocus)=>({ setState: setState })=>{
            setState({
                commentContainerToFocus: commentContainerToFocus
            });
        },
    setAddFooterCommentAdf: (addFooterCommentAdf)=>({ setState: setState })=>{
            setState({
                addFooterCommentAdf: addFooterCommentAdf
            });
        },
    setCachedSummary: (cachedSummary)=>({ setState: setState })=>{
            setState({
                cachedSummary: cachedSummary
            });
        },
    setCurrentSidebarTab: (tab)=>({ setState: setState })=>{
            setState({
                currentSidebarTab: tab
            });
        }
};
const $4440a0699c7a4c4d$var$CommentsStore = (0, $1P1Tu.createStore)({
    initialState: $4440a0699c7a4c4d$var$getInitialState(),
    actions: $4440a0699c7a4c4d$var$actions,
    name: 'CommentsStore'
});
const $4440a0699c7a4c4d$export$8607294e360a4610 = (0, $9zUhf.createHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$1719a5796ebd8e85 = (0, $9zUhf.createActionsHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb = (0, $9zUhf.createStateHook)($4440a0699c7a4c4d$var$CommentsStore);
module.exports["ViewValues"] = $4440a0699c7a4c4d$export$ca559f4ef107f965;
module.exports["SortValues"] = $4440a0699c7a4c4d$export$edda0a7e0ba757fd;
module.exports["CommentMode"] = $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c;
module.exports["AddFooterCommentMode"] = $4440a0699c7a4c4d$export$94f8d08c2312472b;
module.exports["SidebarTabValues"] = $4440a0699c7a4c4d$export$6a393d893fab1730;
module.exports["useCommentsPanel"] = $4440a0699c7a4c4d$export$8607294e360a4610;
module.exports["useCommentsPanelActions"] = $4440a0699c7a4c4d$export$1719a5796ebd8e85;
module.exports["useCommentsPanelState"] = $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb;

});

parcelRegister("dANtQ", function(module, exports) {

var $i1slQ = parcelRequire("i1slQ");


var $9wEpK = parcelRequire("9wEpK");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");

const $be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery = (0, $i1slQ.default);
const $be6154107952d370$var$noOpRefetch = ()=>Promise.resolve();
const $be6154107952d370$export$4cae5d8963399c48 = (contentId, cacheOnly = false)=>{
    const baseOptions = {
        variables: {
            contentId: contentId
        },
        skip: !contentId
    };
    const queryResult = (0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_queries', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)($be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery, baseOptions) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)($be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery, {
        ...baseOptions,
        notifyOnNetworkStatusChange: true,
        fetchPolicy: cacheOnly ? 'cache-only' : 'cache-and-network',
        __callerPackage__: "@confluence/comments-hooks"
    });
    const { data: data, loading: loading, error: error } = queryResult;
    const networkStatus = 'networkStatus' in queryResult && queryResult.networkStatus !== undefined ? queryResult.networkStatus : (0, $9wEpK.NetworkStatus).ready;
    const refetch = 'refetch' in queryResult && typeof queryResult.refetch === 'function' ? queryResult.refetch : $be6154107952d370$var$noOpRefetch;
    const contentNode = data?.content?.nodes?.[0];
    const operations = contentNode?.operations ?? [];
    const createPermission = operations.some((operationResults)=>operationResults?.operation === 'create' && operationResults?.targetType === 'comment');
    return {
        canAddComments: createPermission,
        loading: loading,
        contentQueryError: error,
        refetch: refetch,
        networkStatus: networkStatus
    };
};
module.exports["useAddCommentPermissionCheck"] = $be6154107952d370$export$4cae5d8963399c48;

});

parcelRegister("i1slQ", function(module, exports) {
/**
 * @generated SignedSource<<9576c4641d6e53de65b0b62ec71933b2>>
 * @relayHash 5b33d38d543554afec98c6d129862ca0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c0666e4aa67b4630a3145d746b836d11857cbed57f80ba27619146d9e2fc51f9
const $fc06507f37418bb6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "draft",
                        "current"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5b33d38d543554afec98c6d129862ca0",
            "id": "c0666e4aa67b4630a3145d746b836d11857cbed57f80ba27619146d9e2fc51f9",
            "metadata": {},
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "operationKind": "query",
            "text": "query useAddCommentPermissionCheckPermissionCheckAddCommentQuery($contentId:ID!){content(id:$contentId,status:[\"draft\",\"current\"]){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$fc06507f37418bb6$var$node.hash = "aad09466db1f47073b1a0249e54dc3a4";
var $fc06507f37418bb6$export$2e2bcd8739ae039 = $fc06507f37418bb6$var$node;
module.exports["default"] = $fc06507f37418bb6$export$2e2bcd8739ae039;

});

parcelRegister("l2zNi", function(module, exports) {

let $f5158cd2e6d63fc4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f5158cd2e6d63fc4$var$load("ijAU0"),
    $f5158cd2e6d63fc4$var$load("1WCMN"),
    $f5158cd2e6d63fc4$var$load("iDERe"),
    $f5158cd2e6d63fc4$var$load("3Bbwl"),
    $f5158cd2e6d63fc4$var$load("7EorR"),
    $f5158cd2e6d63fc4$var$load("i0T1W"),
    $f5158cd2e6d63fc4$var$load("bZz7X")
]).then(()=>parcelRequire('g9dNl'));

});

parcelRegister("cdvIH", function(module, exports) {

let $8e4f4dddced3939a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8e4f4dddced3939a$var$load("kHOMt"),
    $8e4f4dddced3939a$var$load("i0T1W"),
    $8e4f4dddced3939a$var$load("ijAU0"),
    $8e4f4dddced3939a$var$load("1WCMN"),
    $8e4f4dddced3939a$var$load("7cWko"),
    $8e4f4dddced3939a$var$load("6wr18"),
    $8e4f4dddced3939a$var$load("ffEVr"),
    $8e4f4dddced3939a$var$load("gYeBT"),
    $8e4f4dddced3939a$var$load("8LtYa"),
    $8e4f4dddced3939a$var$load("jXA76"),
    $8e4f4dddced3939a$var$load("f95iu"),
    $8e4f4dddced3939a$var$load("7k1ns"),
    $8e4f4dddced3939a$var$load("70IPm"),
    $8e4f4dddced3939a$var$load("4iy7m"),
    $8e4f4dddced3939a$var$load("iDERe"),
    $8e4f4dddced3939a$var$load("h3ABO"),
    $8e4f4dddced3939a$var$load("kC80R"),
    $8e4f4dddced3939a$var$load("7EorR"),
    $8e4f4dddced3939a$var$load("6q8Rl")
]).then(()=>parcelRequire('gFN6K'));

});

parcelRegister("6PB7O", function(module, exports) {

let $4f944dbe79d36182$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4f944dbe79d36182$var$load("6wr18"),
    $4f944dbe79d36182$var$load("ffEVr"),
    $4f944dbe79d36182$var$load("jtuzz")
]).then(()=>parcelRequire('ioFqb'));

});

parcelRegister("eIWjB", function(module, exports) {

let $ab8268ebe07d7bfb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ab8268ebe07d7bfb$var$load("h3ABO"),
    $ab8268ebe07d7bfb$var$load("5NQgH"),
    $ab8268ebe07d7bfb$var$load("ijAU0"),
    $ab8268ebe07d7bfb$var$load("1WCMN"),
    $ab8268ebe07d7bfb$var$load("6wr18"),
    $ab8268ebe07d7bfb$var$load("2PePB"),
    $ab8268ebe07d7bfb$var$load("iJF2W"),
    $ab8268ebe07d7bfb$var$load("1GCFv"),
    $ab8268ebe07d7bfb$var$load("4gQSc"),
    $ab8268ebe07d7bfb$var$load("cLmw6"),
    $ab8268ebe07d7bfb$var$load("7tua6"),
    $ab8268ebe07d7bfb$var$load("3YQB7"),
    $ab8268ebe07d7bfb$var$load("a9w2G"),
    $ab8268ebe07d7bfb$var$load("gYeBT"),
    $ab8268ebe07d7bfb$var$load("cmqxT"),
    $ab8268ebe07d7bfb$var$load("cV1Ln"),
    $ab8268ebe07d7bfb$var$load("c0qAG"),
    $ab8268ebe07d7bfb$var$load("3EXzu"),
    $ab8268ebe07d7bfb$var$load("9ijrN"),
    $ab8268ebe07d7bfb$var$load("lkOIY"),
    $ab8268ebe07d7bfb$var$load("5CkG5"),
    $ab8268ebe07d7bfb$var$load("j1p8s"),
    $ab8268ebe07d7bfb$var$load("b7Mr5"),
    $ab8268ebe07d7bfb$var$load("89ROx"),
    $ab8268ebe07d7bfb$var$load("3GuOt"),
    $ab8268ebe07d7bfb$var$load("dI1Cd"),
    $ab8268ebe07d7bfb$var$load("3SIKD"),
    $ab8268ebe07d7bfb$var$load("jYq7y"),
    $ab8268ebe07d7bfb$var$load("jbxHq"),
    $ab8268ebe07d7bfb$var$load("l0dTs"),
    $ab8268ebe07d7bfb$var$load("cyGuT"),
    $ab8268ebe07d7bfb$var$load("ffEVr"),
    $ab8268ebe07d7bfb$var$load("Wowvf"),
    $ab8268ebe07d7bfb$var$load("hhss7"),
    $ab8268ebe07d7bfb$var$load("i0T1W"),
    $ab8268ebe07d7bfb$var$load("f95iu"),
    $ab8268ebe07d7bfb$var$load("7k1ns"),
    $ab8268ebe07d7bfb$var$load("6bVVs"),
    $ab8268ebe07d7bfb$var$load("7mo6o"),
    $ab8268ebe07d7bfb$var$load("6VoH9"),
    $ab8268ebe07d7bfb$var$load("fNa2t"),
    $ab8268ebe07d7bfb$var$load("70IPm"),
    $ab8268ebe07d7bfb$var$load("4iy7m"),
    $ab8268ebe07d7bfb$var$load("lOhGw"),
    $ab8268ebe07d7bfb$var$load("5GaTI"),
    $ab8268ebe07d7bfb$var$load("gepVN"),
    $ab8268ebe07d7bfb$var$load("cj0Rr"),
    $ab8268ebe07d7bfb$var$load("7cWko"),
    $ab8268ebe07d7bfb$var$load("32WMp"),
    $ab8268ebe07d7bfb$var$load("aFko5"),
    $ab8268ebe07d7bfb$var$load("02PJm"),
    $ab8268ebe07d7bfb$var$load("iDERe"),
    $ab8268ebe07d7bfb$var$load("jgDEy"),
    $ab8268ebe07d7bfb$var$load("8ublV"),
    $ab8268ebe07d7bfb$var$load("ddpUk"),
    $ab8268ebe07d7bfb$var$load("4FhBG"),
    $ab8268ebe07d7bfb$var$load("7EorR"),
    $ab8268ebe07d7bfb$var$load("gd3iv")
]).then(()=>parcelRequire('5hqV2'));

});

parcelRegister("k1YtK", function(module, exports) {

let $e952d07f967d1683$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e952d07f967d1683$var$load("kHOMt"),
    $e952d07f967d1683$var$load("i0T1W"),
    $e952d07f967d1683$var$load("ijAU0"),
    $e952d07f967d1683$var$load("1WCMN"),
    $e952d07f967d1683$var$load("7cWko"),
    $e952d07f967d1683$var$load("6wr18"),
    $e952d07f967d1683$var$load("ffEVr"),
    $e952d07f967d1683$var$load("gYeBT"),
    $e952d07f967d1683$var$load("8LtYa"),
    $e952d07f967d1683$var$load("jXA76"),
    $e952d07f967d1683$var$load("f95iu"),
    $e952d07f967d1683$var$load("7k1ns"),
    $e952d07f967d1683$var$load("70IPm"),
    $e952d07f967d1683$var$load("4iy7m"),
    $e952d07f967d1683$var$load("iDERe"),
    $e952d07f967d1683$var$load("6q8Rl"),
    $e952d07f967d1683$var$load("h3ABO"),
    $e952d07f967d1683$var$load("kC80R"),
    $e952d07f967d1683$var$load("7EorR"),
    $e952d07f967d1683$var$load("ioZhb")
]).then(()=>parcelRequire('eBrKE'));

});

parcelRegister("aOVTE", function(module, exports) {

let $7e0b7bf66cc7cef5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7e0b7bf66cc7cef5$var$load("ijAU0"),
    $7e0b7bf66cc7cef5$var$load("1WCMN"),
    $7e0b7bf66cc7cef5$var$load("iDERe"),
    $7e0b7bf66cc7cef5$var$load("3Bbwl"),
    $7e0b7bf66cc7cef5$var$load("7EorR"),
    $7e0b7bf66cc7cef5$var$load("i0T1W"),
    $7e0b7bf66cc7cef5$var$load("bZz7X"),
    $7e0b7bf66cc7cef5$var$load("7f4Qm")
]).then(()=>parcelRequire('5f3kS'));

});

parcelRegister("iBnoc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0360a9befc1d1e18$export$d101cbe06551091d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1wNs0",
    name: "UnreadIndicator",
    loader: async ()=>(await (parcelRequire("9bA4s"))).UnreadIndicator
});
module.exports["UnreadIndicator"] = $0360a9befc1d1e18$export$d101cbe06551091d;

});

parcelRegister("9bA4s", function(module, exports) {

let $6b011f0f99d5e581$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b011f0f99d5e581$var$load("i8hiG").then(()=>parcelRequire('yTrVP'));

});

parcelRegister("fHAwL", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $7fff4328005dca96$var$initialState = {
    // isUpdatingUnreadComments tracks when we're updating the unread comments set
    // (e.g., during initial render or when manually updating the set).
    isUpdatingUnreadComments: true,
    // isUnreadQueryLoading tracks when we're actively fetching comments from the server.
    isUnreadQueryLoading: false,
    unreadCommentIDSet: new Set(),
    shouldClearVisibleThreads: false
};
const $7fff4328005dca96$var$actions = {
    setIsUpdatingUnreadComments: (isUpdatingUnreadComments)=>({ setState: setState })=>{
            setState({
                isUpdatingUnreadComments: isUpdatingUnreadComments
            });
        },
    setIsUnreadQueryLoading: (loading)=>({ setState: setState })=>{
            setState({
                isUnreadQueryLoading: loading
            });
        },
    updateUnreadCommentIDSet: (unreadCommentIDSet, operation = 'initialize')=>({ setState: setState, getState: getState })=>{
            const { unreadCommentIDSet: existingSet } = getState();
            switch(operation){
                case 'initialize':
                    setState({
                        unreadCommentIDSet: unreadCommentIDSet
                    });
                    break;
                case 'add':
                    setState({
                        unreadCommentIDSet: new Set([
                            ...existingSet,
                            ...unreadCommentIDSet
                        ])
                    });
                    break;
                case 'remove':
                    const newSet = new Set(existingSet);
                    unreadCommentIDSet.forEach((id)=>newSet.delete(id));
                    setState({
                        unreadCommentIDSet: newSet
                    });
                    break;
                case 'removeAll':
                    setState({
                        unreadCommentIDSet: new Set()
                    });
                    break;
            }
        },
    setShouldClearVisibleThreads: (shouldClearVisibleThreads)=>({ setState: setState })=>{
            setState({
                shouldClearVisibleThreads: shouldClearVisibleThreads
            });
        }
};
const $7fff4328005dca96$var$UnreadCommentsStore = (0, $1P1Tu.createStore)({
    initialState: $7fff4328005dca96$var$initialState,
    actions: $7fff4328005dca96$var$actions,
    name: 'UnreadCommentsStore'
});
const $7fff4328005dca96$export$df6365a5248dcd96 = (0, $9zUhf.createHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$b7fe87478f70c759 = (0, $9zUhf.createActionsHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$fdd0a0c032c12265 = (0, $9zUhf.createStateHook)($7fff4328005dca96$var$UnreadCommentsStore);
module.exports["useUnreadComments"] = $7fff4328005dca96$export$df6365a5248dcd96;
module.exports["useUnreadCommentsActions"] = $7fff4328005dca96$export$b7fe87478f70c759;
module.exports["useUnreadCommentsState"] = $7fff4328005dca96$export$fdd0a0c032c12265;

});


//# sourceMappingURL=CommentPanelButton.fea3b3a5.js.map
